import { css } from '@emotion/react';
import { theme } from 'global';

export const container = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 0 24px;

  @media screen and (min-width: ${theme.breaks.mdOnboarding}px) {
    padding-top: 72px;
  }
`;

export const icon = css`
  width: 96px;
  height: 96px;
  margin-bottom: 20px;
`;

export const content = css`
  width: 100%;
  max-width: 600px;
`;

export const title = css`
  margin: 0 0 12px;
  color: ${theme.colors.secondary};
`;

export const body = css`
  margin: 0;
  color: ${theme.colors.neutral[600]};
`;

export const resendRow = css`
  margin: 20px 0 0;
  color: ${theme.colors.neutral[600]};
`;

export const inlineButton = css`
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: ${theme.colors.primary.medium};
  font-weight: ${theme.fontWeights.medium};
`;

export const divider = css`
  width: 100%;
  height: 1px;
  margin: 20px auto;
  background: ${theme.colors.neutral[200]};
`;

export const secondaryBody = css`
  margin: 0 0 16px;
  color: ${theme.colors.neutral[600]};
`;

export const primaryButton = css`
  min-width: 96px;
`;
